module.exports = __webpack_public_path__ + "img/desc1_pc.edad00aa.svg";